import React, { useEffect, useRef } from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';
import Image, { IImage } from '../Image';
import Tabs from '../Tabs';
import Tab from '../Tab';
import Video, { IVideoProps } from '../VHSMediaModal';
export interface IVHSSummaryItems {
	/**
	 * Media
	 */
	media?: IVideoProps;
	/**
	 * Images
	 */
	image?: IImage;
	/**
	 *  Thumbnail
	 */
	thumbnail?: IImage;
	/**
	 *  Style
	 */
	style: 'modal' | 'inline';
}
export interface IVHSSummaryFootnotes {
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 *  text
	 */
	text?: string;
}
export interface IVHSSummaryProps extends IBaseElementProps {
	/**
	 * Items
	 */
	items?: IVHSSummaryItems[];
	/**
	 * Footnotes
	 */
	footnotes?: IVHSSummaryFootnotes[];
}

/**
 * Summary
 * @block
 * @icon id
 */
const VHSSummary: React.FC<IVHSSummaryProps> = ({
	items = [],
	footnotes = [],
	className,
	classNames = [],
}) => {

	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!ref.current) {
			return;
		}

		const handleVideos = (event: any) => {
			const videos = ref.current?.querySelectorAll(
				'.vhs-summary__video .vhs-video-inline .video__player',
			) as NodeListOf<HTMLVideoElement>;
			videos && videos.forEach((video) => {
				video.pause();
			});
		};

		const handleTabChange = () => {
			const tabs = ref.current?.querySelectorAll(
				'.vhs-summary__tabs .nav-link',
			) as NodeListOf<HTMLButtonElement>;

			tabs && tabs.forEach((tab) => {
				tab.addEventListener('click', handleVideos);
			});
		};

		const handleTabAccessibility = (event: any) => {
			const tabs = ref.current?.querySelectorAll(
				'.vhs-summary__tabs .nav-item',
			) as NodeListOf<HTMLElement>;
			tabs && tabs.forEach((tab) => {
				tab.removeAttribute('role');
				const button = tab.querySelector('button');
				button.setAttribute('aria-label', 'View media');
			});
		};

		const document = window.document;
		document.addEventListener('DOMContentLoaded', handleTabChange);
		document.addEventListener('DOMContentLoaded', handleTabAccessibility);

		return () => {
			document.removeEventListener('DOMContentLoaded', handleTabChange);
			document.removeEventListener('DOMContentLoaded', handleTabAccessibility);
		};
	}, []);

	return (
		<div className={className || cn('vhs-summary', ...classNames)} 	ref={ref}>
			{items.length > 0 && footnotes.length > 0 &&
			<div className="vhs-summary__container">
				{items.filter((item) => item.thumbnail).length > 0 &&
					<Tabs className="vhs-summary__tabs">
						{items.filter((item, index) => index < 4 && item.thumbnail).map((item, index) => {
							return (
								<Tab
									// Component being updated to in tbk-component to add support for React elements to be added here
									// @ts-ignore
									title={(<Image {...item.thumbnail} />)}
									key={index}
									id={`vhs-summary-key-tab-${index}`}
								>
									<div className="vhs-summary__tab-wrapper">
										<>
											{(item?.media?.poster?.src) && (
												<Video className="vhs-summary__video" {...item?.media} style={item?.style} />
											)}
											{(item?.image?.src) && (
												<Video className="vhs-summary__video" poster={item?.image} style={item?.style}  />
											)}
										</>
									</div>
								</Tab>
							)}
						)}
					</Tabs>
				}
				{footnotes.length > 0 &&
				<div className="vhs-summary__footnotes">
					{footnotes.map(({heading, text}, index) => {
							if (index < 4) {
								return (
									<div key={index} className="vhs-summary__footnote">
										<div className="vhs-summary__heading">{heading}</div>
										<div className="vhs-summary__text">{text}</div>
									</div>
								)
							}
						}
					)}
				</div>
				}
			</div>
			}
		</div>
	);
};

export default VHSSummary;
